module.exports = __webpack_public_path__ + "img/emoji_83.13d381c3.png";